import { render, staticRenderFns } from "./SchedulePractice.vue?vue&type=template&id=0a90a138&scoped=true"
import script from "./SchedulePractice.vue?vue&type=script&lang=js"
export * from "./SchedulePractice.vue?vue&type=script&lang=js"
import style0 from "./SchedulePractice.vue?vue&type=style&index=0&id=0a90a138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90a138",
  null
  
)

export default component.exports